import React, { useEffect, useMemo, useState, useCallback } from "react"
import { useDebounce } from "hooks/useDebounce"
import { withRouter } from "react-router-dom"
import TableContainer from "components/Common/TableContainer"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import * as url from "../../helpers/url_helper"

import { Label, BrandName, UserCashback, State, MerchantName, MerchantLocation } from "./offerCol"

import Breadcrumbs from "components/Common/Breadcrumb"

import {
    getOperationOffers as onGetOperationOffers,
    clearOperationOffers,
    manageOperationOffer,
    getOfferStateHistory as onGetOfferStateHistory,
    clearOfferStateHistory,
    rejectOffer,
    processOffer
} from "store/offers/actions"

import { useSelector, useDispatch } from "react-redux"
import AccessControlWrapper from "components/Common/PermissionButton"
import { PageTitle } from "constants/ui"
import CButton from "components/Common/CButton"
import IconButton from "components/Common/IconButton"
import ConfirmButton from "components/Common/ConfirmButton"
import OfferStateHistoryModal from "components/Offers/OfferStateHistoryModel"
import OfferActionModal from "components/Offers/OfferActionModal"
import { getFirstTabPermission } from "helpers/tab_helper"
import { calculatePageAfterAction, calculateStartIndex } from "helpers/pagination_helper"

const OperationOffersList = props => {
    document.title = PageTitle.OPERATION_OFFERS_LIST

    const [search, setSearch] = useState("")
    const [page, setPage] = useState(1)
    const [historyModal, setHistoryModal] = useState(false)
    const [selectedStates, setSelectedStates] = useState([])
    const [actionModal, setActionModal] = useState({ isOpen: false, offerID: null, actionType: null })

    const dispatch = useDispatch()

    const { history } = props

    const { data, userMenu } = useSelector(state => ({
        data: state.offers,
        userMenu: state.userMenu?.userMenu || [],
    }))

    const firstTabPermission = getFirstTabPermission("OPERATION_OFFERS_DETAIL", userMenu)

    const columns = useMemo(
        () => [
            {
                Header: "Image",
                accessor: "image",
                disableFilters: true,
                filterable: true,

                accessor: cellProps => (
                    <>
                        {!cellProps.image ? (
                            <div className="avatar-xs">
                                <span className="avatar-title rounded-circle">
                                    {cellProps.label?.charAt(0) || "O"}
                                </span>
                            </div>
                        ) : (
                            <div>
                                <img
                                    className="rounded-circle avatar-xs"
                                    src={cellProps.image}
                                    alt=""
                                />
                            </div>
                        )}
                    </>
                ),
            },
            {
                Header: "Label",
                accessor: "label",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <Label {...cellProps} />
                },
            },
            {
                Header: "Brand",
                accessor: "brand",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <BrandName {...cellProps} />
                },
            },
            {
                Header: "Merchant Name",
                accessor: "merchant.displayName",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <MerchantName {...cellProps} />
                },
            },
            {
                Header: "Merchant Location",
                accessor: "merchant.legalEntityAddress",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <MerchantLocation {...cellProps} />
                },
            },
            {
                Header: "Cashback %",
                accessor: "userCashbackPercentage",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <UserCashback {...cellProps} />
                },
            },
            {
                Header: "State",
                accessor: "state",
                filterable: true,
                disableFilters: true,
                Cell: cellProps => {
                    return <State {...cellProps} />
                },
            },
            {
                Header: "Action",
                Cell: cellProps => {
                    return (
                        <div className="d-flex gap-2">
                            <AccessControlWrapper
                                actionType={firstTabPermission?.actionType || "get"}
                                contextUri={firstTabPermission?.contextUri || url.GET_OPERATION_OFFERS}
                                history={history}
                            >
                                <IconButton.View
                                    onClick={() => {
                                        const offerID = cellProps.row.original.offerID
                                        history.push(`/operation-offers/${offerID}`)
                                    }}
                                />
                            </AccessControlWrapper>
                            {/* <AccessControlWrapper
                                actionType="post"
                                contextUri={url.MANAGE_CURATOR_OFFER}
                                history={history}
                            >
                                <IconButton
                                    icon="bx bx-copy"
                                    color="secondary"
                                    title="Copy Offer"
                                    onClick={() => {
                                        const offerID = cellProps.row.original.offerID
                                        history.push(`/curator-offers/add?copyFrom=${offerID}&fromType=operation`)
                                    }}
                                />
                            </AccessControlWrapper> */}
                            <AccessControlWrapper
                                actionType="get"
                                contextUri={url.GET_OFFER_STATE_HISTORY}
                                history={history}
                            >
                                <IconButton.History onClick={() => showHistoryModal(cellProps.row.original.offerID)} />
                            </AccessControlWrapper>
                            {(cellProps.row.original.state.toLowerCase() === 'posted' || cellProps.row.original.state.toLowerCase() === 'denied') && (
                                <>
                                    <AccessControlWrapper
                                        actionType="post"
                                        contextUri={url.PROCESS_OFFER}
                                        history={history}
                                    >
                                        <IconButton.Process
                                            onClick={() => handleActionClick(cellProps.row.original.offerID, 'process')}
                                        />
                                    </AccessControlWrapper>
                                    <AccessControlWrapper
                                        actionType="post"
                                        contextUri={url.REJECT_OFFER}
                                        history={history}
                                    >
                                        <IconButton.Reject
                                            onClick={() => handleActionClick(cellProps.row.original.offerID, 'reject')}
                                        />
                                    </AccessControlWrapper>
                                </>
                            )}
                            <ConfirmButton
                                onConfirm={() =>
                                    handleDeleteOperationOffer(
                                        cellProps.row.original.offerID
                                    )
                                }
                                message="Are you sure you want to delete this Operation Offer? This action cannot be undone."
                                renderButton={<IconButton.Delete />}
                                contextUri={url.MANAGE_OPERATIONS_OFFER}
                                actionType="post"
                            ></ConfirmButton>
                        </div>
                    )
                },
            },
        ],
        []
    )

    useEffect(() => {
        dispatch(
            onGetOperationOffers({
                headers: {
                    "input-parameters": {},
                },
                pagination: { startIndex: 0 },
            })
        )
    }, [dispatch])

    useEffect(() => {
        return () => {
            dispatch(clearOperationOffers())
            dispatch(clearOfferStateHistory())
        }
    }, [dispatch])

    const rowClick = (e, row) => {
        const {
            original: { offerID },
        } = row
        history.push({
            pathname: `/operation-offers/${offerID}`,
        })
    }

    const showHistoryModal = (offerID) => {
        setHistoryModal(true)
        dispatch(
            onGetOfferStateHistory({
                headers: {
                    "input-parameters": { offerID: offerID },
                },
            })
        )
    }

    const closeHistoryModal = () => {
        setHistoryModal(false)
        dispatch(clearOfferStateHistory())
    }

    const dispatchSearch = useCallback((value) => {
        setPage(1)
        dispatch(
            onGetOperationOffers({
                headers: {
                    "input-parameters": {
                        keyword: value || "",
                        ...(selectedStates.length > 0 && { states: selectedStates })
                    },
                },
                pagination: { startIndex: 0 },
            })
        )
    }, [dispatch, selectedStates])

    const [debouncedSearch] = useDebounce(dispatchSearch)

    const handleSearchChange = e => {
        const { value } = e.target
        setSearch(value)
        debouncedSearch(value)
    }

    const handlePageChange = page => {
        const startIndex = (page - 1) * 10
        setPage(page)
        dispatch(
            onGetOperationOffers({
                headers: {
                    "input-parameters": {
                        keyword: search || "",
                        ...(selectedStates.length > 0 && { states: selectedStates })
                    },
                },
                pagination: { startIndex },
            })
        )
    }

    const handleRefresh = () => {
        dispatch(
            onGetOperationOffers({
                headers: {
                    "input-parameters": {
                        keyword: search || "",
                        ...(selectedStates.length > 0 && { states: selectedStates })
                    },
                },
                pagination: { startIndex: (page - 1) * 10 },
            })
        )
    }

    const handleDeleteOperationOffer = offerID => {
        const targetPage = calculatePageAfterAction(page, data.operationOffers?.length || 0)
        const inputParams = { keyword: search || "" }
        if (selectedStates.length > 0) {
            inputParams.states = selectedStates
        }
        dispatch(
            manageOperationOffer({
                offerID: offerID,
                actionType: "delete",
                refreshPagination: {
                    startIndex: calculateStartIndex(targetPage),
                    inputParams
                }
            })
        )
        setPage(targetPage)
    }

    const handleStateChange = (state) => {
        const updatedStates = selectedStates.includes(state)
            ? selectedStates.filter(s => s !== state)
            : [...selectedStates, state]

        setSelectedStates(updatedStates)

        if (page > 1) {
            setPage(1)
        }

        dispatch(
            onGetOperationOffers({
                headers: {
                    "input-parameters": {
                        keyword: search || "",
                        ...(updatedStates.length > 0 && { states: updatedStates })
                    },
                },
                pagination: { startIndex: 0 },
            })
        )
    }

    const handleActionClick = (offerID, actionType) => {
        setActionModal({
            isOpen: true,
            offerID: offerID,
            actionType: actionType
        })
    }

    const closeActionModal = () => {
        setActionModal({ isOpen: false, offerID: null, actionType: null })
    }

    const handleActionSubmit = (payload) => {
        const inputParams = { keyword: search || "" }
        if (selectedStates.length > 0) {
            inputParams.states = selectedStates
        }
        const payloadWithPagination = {
            ...payload,
            refreshPagination: {
                startIndex: calculateStartIndex(page),
                inputParams
            }
        }
        if (actionModal.actionType === 'process') {
            dispatch(processOffer(payloadWithPagination))
        } else if (actionModal.actionType === 'reject') {
            dispatch(rejectOffer(payloadWithPagination))
        }
    }

    const getActionModalTitle = () => {
        if (actionModal.actionType === 'process') return 'Process Offer'
        if (actionModal.actionType === 'reject') return 'Reject Offer'
        return 'Action'
    }

    const getActionModalUri = () => {
        if (actionModal.actionType === 'process') return url.PROCESS_OFFER
        if (actionModal.actionType === 'reject') return url.REJECT_OFFER
        return ''
    }

    const getActionConfirmMessage = () => {
        if (actionModal.actionType === 'process') return 'Are you sure you want to process this offer?'
        if (actionModal.actionType === 'reject') return 'Are you sure you want to reject this offer?'
        return 'Are you sure you want to proceed?'
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title={PageTitle.OPERATION_OFFERS_LIST}
                        titleLink="/operation-offers"
                        breadcrumbItem={PageTitle.OPERATION_OFFERS_LIST}
                    />
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="6">
                                            <div className="d-flex gap-3 align-items-center">
                                                <input
                                                    type="text"
                                                    placeholder="search operation offers"
                                                    onChange={handleSearchChange}
                                                    className="form-control w-50 rounded-pill"
                                                />
                                                <div className="d-flex gap-2 align-items-center">
                                                    <div className="form-check form-check-primary">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="posted"
                                                            checked={selectedStates.includes('posted')}
                                                            onClick={() => handleStateChange('posted')}
                                                        />
                                                        <label className="form-check-label" htmlFor="posted">
                                                            Posted
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-primary">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id="denied"
                                                            checked={selectedStates.includes('denied')}
                                                            onClick={() => handleStateChange('denied')}
                                                        />
                                                        <label className="form-check-label" htmlFor="denied">
                                                            Denied
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Delete Error Alert */}
                                    {data?.operationDeleteError?.message && (
                                        <Row className="mb-3">
                                            <Col lg="12">
                                                <div className="alert alert-danger" role="alert">
                                                    <strong>Delete Error:</strong> {data.operationDeleteError.message}
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    <TableContainer
                                        columns={columns}
                                        data={data?.operationError?.message ? [] : data.operationOffers}
                                        isGlobalFilter={false}
                                        isAddUserList={true}
                                        rowClick={rowClick}
                                        protectedRowClick={true}
                                        contextUri={url.GET_OPERATION_OFFERS}
                                        actionType="get"
                                        customPageSize={10}
                                        className="custom-header-css"
                                        columnFilter={false}
                                        changePageSize={false}
                                        onPageChange={handlePageChange}
                                        currentPage={page}
                                        hasNextPage={!data?.operationError?.message && data.operationOffers?.length >= 10}
                                        onRefresh={handleRefresh}
                                        refreshContextUri={url.GET_OPERATION_OFFERS}
                                        refreshActionType="get"
                                        history={history}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* History Modal */}
            <OfferStateHistoryModal
                isOpen={historyModal}
                toggle={closeHistoryModal}
                historyData={data.offerStateHistory}
                isLoading={data.isLoadingOfferStateHistory}
            />

            {/* Action Modal */}
            <OfferActionModal
                isOpen={actionModal.isOpen}
                toggle={closeActionModal}
                title={getActionModalTitle()}
                actionType={actionModal.actionType}
                offerID={actionModal.offerID}
                onSubmit={handleActionSubmit}
                isLoading={data.isLoadingProcessOffer || data.isLoadingRejectOffer}
                contextUri={getActionModalUri()}
                confirmMessage={getActionConfirmMessage()}
            />
        </React.Fragment>
    )
}

export default withRouter(OperationOffersList)